var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDuplexStructure = function SvgDuplexStructure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#duplex-structure_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 1,
    x: 2,
    y: 6,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 1,
    x: 12,
    y: 6,
    rx: 0.5,
    transform: "rotate(90 12 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 18,
    y: 10,
    rx: 0.5,
    transform: "rotate(-180 18 10)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 18,
    y: 13,
    rx: 0.5,
    transform: "rotate(-180 18 13)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 18,
    y: 16,
    rx: 0.5,
    transform: "rotate(-180 18 16)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 18,
    x: 2.5,
    y: 0.5,
    stroke: "currentColor",
    rx: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "duplex-structure_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 19,
    x: 2,
    fill: "#fff",
    rx: 2
  })))));
};
export default SvgDuplexStructure;